import { observer } from "mobx-react-lite";
import MainLayout, { MAIN_RIGHT_TOP_HEIGHT } from "../MainLayout";
import { useLocation, useNavigate } from "react-router-dom";
import { HorizontalLayout, VerticalLayout } from "../../common/common-layout";
import { TitleLargeMedium, TitleMediumBold, TitleNormal, TitleNormalBold } from "../../common/common-text";
import BTBox from "../../common/components/BTBox";
import { useEffect, useState } from "react";
import { formatDateToYMD } from "../../common/utils/DateUtils";
import CustomerInquiry from "../../model/homepage/CustomerInquiry";
import BTInputBox from "../../common/components/BTInputBox";
import BTButton from "../../common/components/BTButton";
import theme from "../../common/theme";
import Divider from "@mui/material/Divider";
import BTMultilineInputBox from "../../common/components/BTMultilineInputBox";

const CustomerInquiriesDetail = () => {
    return (
        <MainLayout>
            <CustomerInquiriesDetailBody />
        </MainLayout>
    );
};

export default CustomerInquiriesDetail;

const CustomerInquiriesDetailBody = observer(() => {
    const location = useLocation();
    const navigate = useNavigate();
    const [inquiry, setInquiry] = useState<CustomerInquiry>();

    useEffect(() => {
        if (location.state) {
            setInquiry(location.state as CustomerInquiry);
        }
    }, [location.state]);

    const handleWriteReply = () => {
        navigate('/homepage/inquiries/reply', { state: inquiry });
    };

    const handleNavigateToList = () => {
        navigate('/homepage/inquiries');
    };

    return (
        <div style={{ width: '100%', minHeight: `calc(100vh - ${MAIN_RIGHT_TOP_HEIGHT})`, display: 'flex', flexDirection: 'column' }}>
            <VerticalLayout height={'auto'} paddingLeft={36} paddingRight={36}>
                <TitleLargeMedium>문의하기 상세</TitleLargeMedium>
                <BTBox height="24px" />
                <Divider style={{ width: "100%", backgroundColor: '#D9D9D9' }} />

                {inquiry ? (
                    <VerticalLayout height={'auto'} paddingBottom={36}>
                        <TitleMediumBold style={{ marginTop: "20px" }}>작성자 정보</TitleMediumBold>
                        <BTBox height="16px" />
                        <div
                            style={{
                                display: "flex",
                                gap: "16px",
                                marginTop: "8px",
                                marginBottom: "16px",
                                fontSize: "14px",
                                color: "#6C757D",
                                alignItems: "center",
                                flexWrap: "wrap",
                            }}
                        >
                            <b>접수일</b>
                            <div>{formatDateToYMD(inquiry.createdAt)}</div>
                            <Divider style={{ width: "1px", height: "13px", backgroundColor: "#6C757D" }} />
                            <b>작성자</b>
                            <div>{inquiry.requestorName}</div>
                            <Divider style={{ width: "1px", height: "13px", backgroundColor: "#6C757D" }} />
                            <b>이메일</b>
                            <div>{inquiry.email}</div>
                        </div>

                        <Divider style={{ width: "100%", backgroundColor: '#D9D9D9' }} />

                        <TitleMediumBold style={{ marginTop: "20px" }}>문의 정보</TitleMediumBold>
                        <BTBox height='16px' />

                        {/* 제목 */}
                        <div
                            style={{
                                display: "flex",
                                gap: "16px",
                                alignItems: "center",
                                marginTop: "8px",
                                fontSize: "14px",
                                color: "#6C757D",
                                width: "100%"
                            }}
                        >
                            <div
                                style={{
                                    fontWeight: "700",
                                    minWidth: "48px",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                    overflow: "hidden",
                                }}
                            >
                                제목
                            </div>
                            <div style={{ flex: 1 }}>
                                <BTInputBox value={inquiry.title} disabled />
                            </div>
                        </div>

                        {/* 본문 */}
                        <div
                            style={{
                                display: "flex",
                                gap: "16px",
                                alignItems: "flex-start",
                                marginTop: "8px",
                                fontSize: "14px",
                                color: "#6C757D",
                                width: "100%"
                            }}
                        >
                            <div
                                style={{
                                    fontWeight: "700",
                                    minWidth: "48px",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                    overflow: "hidden",
                                }}
                            >
                                본문
                            </div>
                            <div style={{ flex: 1 }}>
                                <BTMultilineInputBox
                                    value={inquiry.contents}
                                    disabled
                                    style={{ width: '100%', boxSizing: 'border-box' }}
                                />
                            </div>
                        </div>
                        { inquiry.replyCompletedYn ? (
                            <VerticalLayout>
                                <Divider style={{ width: "100%", backgroundColor: '#D9D9D9' }} />
                                <TitleMediumBold style={{ marginTop: "20px" }}>답변 정보</TitleMediumBold>
                                <BTBox height="16px" />

                                {/* 답변 제목 */}
                                <div
                                    style={{
                                        display: "flex",
                                        gap: "16px",
                                        alignItems: "center",
                                        marginTop: "8px",
                                        fontSize: "14px",
                                        color: "#6C757D",
                                        width: "100%"
                                    }}
                                >
                                    <div
                                        style={{
                                            fontWeight: "700",
                                            minWidth: "48px",
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                            overflow: "hidden",
                                        }}
                                    >
                                        제목
                                    </div>
                                    <BTInputBox value={inquiry.replyTitle} disabled />
                                </div>

                                {/* 답변 본문 */}
                                <div
                                    style={{
                                        display: "flex",
                                        gap: "16px",
                                        alignItems: "flex-start",
                                        marginTop: "8px",
                                        fontSize: "14px",
                                        color: "#6C757D",
                                        width: "100%"
                                    }}
                                >
                                    <div
                                        style={{
                                            fontWeight: "700",
                                            minWidth: "48px",
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                            overflow: "hidden",
                                        }}
                                    >
                                        본문
                                    </div>
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <BTMultilineInputBox
                                            value={inquiry.replyContents}
                                            disabled
                                            style={{ width: '100%', boxSizing: 'border-box' }}
                                        />
                                    </div>
                                </div>
                            </VerticalLayout>
                        ) : <div />}
                    </VerticalLayout>
                ) : (
                    <div style={{ fontSize: '16px', color: '#999' }}>
                        조회할 문의건이 없습니다.
                    </div>
                )}
            </VerticalLayout>

            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '40px', marginLeft: '72px', marginRight: '72px' }}>
                <div style={{ display: 'flex', gap: '24px' }}>
                    {
                        inquiry?.replyCompletedYn ? <div /> : (
                            <BTButton color={theme.colors.bbTech} textColor='white' onClick={handleWriteReply}>답변 보내기</BTButton>
                        )
                    }
                    <BTButton onClick={handleNavigateToList}>목록</BTButton>
                </div>
            </div>
        </div>
    );
});